import get from 'lodash/get';
import noop from 'lodash/noop';

export const SETTINGS = {
  defaultParams: {
    parentsLookup: false,
  },
  rootTaxonomyId: 1,
};

export const TAXOMONY_STATES = {
  UNSELECTED: 0,
  HALFSELECTED: 1,
  SELECTED: 2,
};

export const UNITS_CONVERSION_RATIO = {
  px: 1,
  rem: 1 / parseFloat(get(window, 'document.body.css', noop)('font-size')),
};
